import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getPlantRateFluidList = async () => (await axiosInstance.get(`${API_URL}/plant-rate-fluid-list`)).data;
export const getPlantRateFluidListById = async (id) => (await axiosInstance.get(`${API_URL}/plant-rate-fluid-list/${id}`)).data;
export const createPlantRateFluidList = async (payload) => (await axiosInstance.post(`${API_URL}/plant-rate-fluid-list`, payload)).data;
export const updatePlantRateFluidList = async (id, payload) => (await axiosInstance.put(`${API_URL}/plant-rate-fluid-list/${id}`, payload)).data;
export const deletePlantRateFluidList = async (id) => (await axiosInstance.delete(`${API_URL}/plant-rate-fluid-list/${id}`)).data;
